/* ===========================================================
   LUXORA — Motion system (dependency-free)
   - Auto-tags scroll-reveal targets (no markup changes)
   - Staggers siblings as they enter the viewport
   - Hero parallax + entrance choreography
   Presentational only: content is fully usable without it.
   =========================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    if (reduced) return;

    /* ---------- Hero parallax (homepage cinematic bg) ---------- */
    var bg = document.querySelector('.lx-hero .lx-hero__bg');
    if (bg) {
      var ticking = false;
      var parallax = function () {
        ticking = false;
        var y = Math.min(window.scrollY, window.innerHeight);
        bg.style.transform =
          'translate3d(0, ' + (y * 0.16).toFixed(1) + 'px, 0) scale(1.06)';
      };
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(parallax);
          }
        },
        { passive: true }
      );
      parallax();
    }

    /* ---------- Scroll reveals ---------- */
    var SELECTORS = [
      '.lx-trust__row span',
      '.lx-featured__heading > div',
      '.lx-card',
      '.lx-pillar',
      '.lx-privacy__pillars > div',
      '.lx-privacy .lx-wrap > .lx-eyebrow',
      '.lx-privacy .lx-wrap > .lx-display',
      '.lx-tier-row__body > *',
      '.lx-tier-row__visual',
      '.lx-materials__heading > *',
      '.lx-materials__grid > *',
      '.lx-faq__heading > *',
      '.lx-faq__list details',
      '.lxe-sec__head > *',
      '.lxe-tiers > .lxe-tier',
      '.lxe-steps > .lxe-step',
      '.lxe-facts > div',
      '.lxe-note',
      '.lxe-band > *',
      '.lxe-form-shell',
      '.lxe-prose > h2',
      '.lxe-prose > h3',
      '.lxe-prose > p',
      '.lxe-prose > ul',
      '.lxe-prose > details',
      '.lxe-prose > .lxe-facts',
      '.luxora-product__overview > *',
      '.luxora-product__card'
    ];

    var targets = document.querySelectorAll(SELECTORS.join(','));
    if (!('IntersectionObserver' in window) || targets.length === 0) return;

    // Elements already in the first viewport reveal immediately (no flash,
    // and screenshots/headless renders stay correct); the rest animate in
    // as the visitor scrolls.
    var foldLine = window.innerHeight * 0.92;
    var deferred = [];
    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top < foldLine) return;
      el.classList.add('lx-will-reveal');
      deferred.push(el);
    });
    targets = deferred;
    if (targets.length === 0) return;

    var observer = new IntersectionObserver(
      function (entries) {
        // group this batch by parent so siblings stagger together
        var perParent = new Map();
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var parent = entry.target.parentElement || document.body;
          if (!perParent.has(parent)) perParent.set(parent, []);
          perParent.get(parent).push(entry.target);
          observer.unobserve(entry.target);
        });
        perParent.forEach(function (els) {
          els.forEach(function (el, i) {
            el.style.transitionDelay = Math.min(i * 80, 480) + 'ms';
            el.classList.add('lx-revealed');
            el.addEventListener(
              'transitionend',
              function () {
                el.style.transitionDelay = '';
              },
              { once: true }
            );
          });
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  });
})();
